var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    { attrs: { "offset-y": "", left: "" } },
    [
      _c("v-btn", {
        attrs: { fab: "", small: "" },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function ({ on }) {
              return [
                _c("v-avatar", { attrs: { small: "", "pb-2": "" } }, [
                  _vm._v(_vm._s(_vm.initials())),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [_c("v-flex", [_vm._v("User: " + _vm._s(_vm.name))])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c("v-flex", [
                    _vm._v(
                      "Organization: " +
                        _vm._s(_vm.orgName) +
                        " (" +
                        _vm._s(_vm.orgId) +
                        ")"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [_c("v-flex", [_vm._v("Domain: " + _vm._s(_vm.orgDomain))])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [_c("v-flex", [_vm._v("Timezone: " + _vm._s(_vm.timezone))])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "orange" },
                  on: {
                    click: function ($event) {
                      return _vm.logout()
                    },
                  },
                },
                [_vm._v("Logout")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }